'use strict';

define('global/bottom_about/index', ['shared/runtime'], function (Runtime) {
  'use strict';

  var localMap = {
    'zh-cn': 'zh-cn',
    'en-us': 'en-us',
    'es-es': 'es-es',
    'pt-pt': 'pt-pt'
  };

  var biz = {
    showWechatShareLayer: function showWechatShareLayer() {
      this.$wechatQrLayer.stop().show();
    },
    hideWechatShareLayer: function hideWechatShareLayer() {
      this.$wechatQrLayer.hide();
    },
    toggleLocale: function toggleLocale(local) {
      Runtime.changeLocale(local);
    },
    bindEvents: function bindEvents() {
      this.$wechatTrigger.hover(this.showWechatShareLayer.bind(this), this.hideWechatShareLayer.bind(this));
      console.log(this, 77788899);
      $('.js-g-toggle-locale').eq(0).on('click', this.toggleLocale.bind(this, localMap['zh-cn']));
      $('.js-g-toggle-locale').eq(1).on('click', this.toggleLocale.bind(this, localMap['en-us']));
      $('.js-g-toggle-locale').eq(2).on('click', this.toggleLocale.bind(this, localMap['es-es']));
      $('.js-g-toggle-locale').eq(3).on('click', this.toggleLocale.bind(this, localMap['pt-pt']));
    },
    init: function init() {
      this.$wechatTrigger = $('.js-g-footer-wechat-icon');
      this.$wechatQrLayer = $('.js-g-footer-wechat-qr-layer');
      this.bindEvents();
    }
  };

  return {
    init: biz.init.bind(biz)
  };
});